import { createContext, useContext } from "react";
import { usePathologyAdmin } from "./usePathologyAdmin";
import { usePathologyStudent } from "./usePathologyStudent";

const PathologyContext = createContext(null);

export function usePathology() {
  return useContext(PathologyContext);
}

/**
 * Shares pathology state between the sidebar panel and map effects.
 */
export function PathologyRoot({
  isAdmin,
  slideId,
  mapRef,
  mapReadyVersion,
  geoJson,
  children,
}) {
  const admin = usePathologyAdmin({
    enabled: isAdmin,
    slideId,
    mapRef,
    geoJson,
  });
  const student = usePathologyStudent({
    enabled: !isAdmin,
    slideId,
  });

  return (
    <PathologyContext.Provider
      value={{ isAdmin, admin, student, mapRef, mapReadyVersion }}
    >
      <div style={{ display: "contents" }}>{children}</div>
    </PathologyContext.Provider>
  );
}
